import React, { useState, useRef } from 'react';

const StatusDropdownCell = ({ value, options, onChange, onAddOption, currentUser, onEditStatus }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const buttonRef = useRef(null);
  const colorClass = options[value] || options['VAZIO'];
  const isAdmin = currentUser?.role === 'admin';

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setNewStatus('');
  };

  const handleSelect = (key) => {
    onChange(key);
    handleClose();
  };

  const handleClear = () => {
    onChange('VAZIO');
    handleClose();
  };

  const handleCreate = (e) => {
    e.stopPropagation();
    if (newStatus.trim()) {
      onAddOption(newStatus.trim().toUpperCase());
      onChange(newStatus.trim().toUpperCase());
      handleClose();
    }
  };

  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <div ref={buttonRef} className={`w-full h-8 flex items-center justify-center cursor-pointer transition-opacity hover:opacity-90 ${colorClass}`} onClick={() => isOpen ? handleClose() : handleOpen()}>
        {value === 'VAZIO' ? '' : value}
      </div>
      {isOpen && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 z-[99] bg-black/50 backdrop-blur-sm" onClick={handleClose}></div>
          {/* Splash Modal - Centered */}
          <div className="fixed z-[100] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 max-w-[90vw] bg-[#1c1f2b] border border-slate-600 rounded-xl shadow-2xl p-4 flex flex-col gap-2 animate-in fade-in zoom-in-95 duration-200">
            <div className="flex items-center justify-between border-b border-slate-700 pb-3">
              <h3 className="text-white font-semibold text-sm">Alterar Status</h3>
              <button onClick={handleClose} className="text-slate-400 hover:text-white transition-colors">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
            </div>
            <div className="max-h-[60vh] overflow-y-auto py-2">
              <div className="grid grid-cols-3 gap-2">
                {Object.keys(options).map((key) => {
                  if (key === 'VAZIO') return null;
                  const isSelected = key === value;
                  return (
                    <div 
                      key={key} 
                      className={`px-2 py-3 cursor-pointer text-center text-[10px] font-semibold rounded-lg hover:brightness-110 transition-all ${options[key]} ${isSelected ? 'ring-2 ring-white' : ''}`} 
                      onClick={() => handleSelect(key)}
                      title={key}
                    >
                      <span className="line-clamp-2">{key}</span>
                      {isSelected && <span className="block mt-0.5">✓</span>}
                    </div>
                  );
                })}
              </div>
            </div>
            {onAddOption ? (
              <div className="mt-1 pt-3 border-t border-slate-600 flex flex-col gap-2 shrink-0">
                <p className="text-xs text-slate-400">Criar novo status:</p>
                <input 
                  type="text" 
                  placeholder="Nome do status..." 
                  value={newStatus} 
                  onChange={e => setNewStatus(e.target.value)} 
                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-xs text-white focus:outline-none focus:border-blue-500" 
                  onKeyDown={e => { if(e.key === 'Enter' && newStatus.trim()) handleCreate(e); }}
                />
                <button 
                  onClick={handleCreate}
                  className={`w-full bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold py-2 rounded-lg transition-colors ${!newStatus.trim() ? 'opacity-50 cursor-not-allowed' : ''}`} 
                  disabled={!newStatus.trim()}
                >
                  Criar Status
                </button>
              </div>
            ) : null}
            {isAdmin && onEditStatus ? (
              <div className="mt-1 pt-3 border-t border-slate-600 shrink-0">
                <button 
                  onClick={(e) => { e.stopPropagation(); handleClose(); onEditStatus(); }} 
                  className="w-full bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                  Gerenciar / Ordenar Status
                </button>
              </div>
            ) : null}
            <div className="mt-1 pt-3 border-t border-slate-600 shrink-0">
              <button 
                className="w-full px-4 py-2 text-center text-xs font-semibold rounded-lg bg-slate-700 text-slate-300 hover:bg-slate-600 transition-colors"
                onClick={handleClear}
              >
                Limpar Status
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StatusDropdownCell;
